export var revenueActiveLoansDetailsMapper = function (response) {
    if (response) {
        return {
            requestId: response.requestid,
            success: response.success,
            message: response.message,
            statusCode: response.statuscode,
            errors: response.errors,
            currentPage: response.currentpage,
            pageSize: response.pagesize,
            totalPages: response.totalpages,
            totalItems: response.totalitems,
            orderBy: response.orderby,
            orderByDesc: response.orderbydesc,
            data: response.data.length > 0
                ? response.data.map(function (item) {
                    return {
                        LOANCODE: item.loancode,
                        SCRIPTNAME: item.scriptname,
                        NOOFSHARE: item.noofshare,
                        CURRETNMKTPRICE: item.curretnmktprice,
                        TOTALVALUE: item.totalvalue,
                        HAIRCUT: item.haircut,
                        GDPOWER: item.gdpower,
                    };
                })
                : [],
        };
    }
    return {};
};
